import * as XLSX from 'xlsx';
import { CampAccommodationTable, CampTent, CampHall, CampBed } from '../types/camp';

type ExportRow = {
  camp_name: string;
  table_name: string;
  tent_number: number;
  hall_number: number;
  bed_index: number;
  pilgrim_name: string;
  pilgrim_gender: string;
  pilgrim_country: string;
  pilgrim_package: string;
  guide_name: string;
};

export const exportCampAccommodationToExcel = (table: CampAccommodationTable) => {
  const rows: ExportRow[] = [];

  // Convert table data to rows
  table.tents.forEach((tent: CampTent) => {
    tent.halls.forEach((hall: CampHall) => {
      hall.beds.forEach((bed: CampBed, bedIndex: number) => {
        if (bed.pilgrimId) { // Only export occupied beds
          rows.push({
            camp_name: table.campName,
            table_name: table.tableName,
            tent_number: tent.tentNumber,
            hall_number: hall.hallNumber,
            bed_index: bedIndex + 1,
            pilgrim_name: bed.pilgrimName || '',
            pilgrim_gender: bed.gender || '',
            pilgrim_country: bed.country || '',
            pilgrim_package: bed.packageName || '',
            guide_name: bed.guideName || ''
          });
        }
      });
    });
  });

  // Create worksheet
  const ws = XLSX.utils.json_to_sheet(rows);

  // Add Arabic headers
  XLSX.utils.sheet_add_aoa(ws, [[
    'اسم المخيم',
    'اسم الجدول',
    'رقم الخيمة',
    'رقم الصالة',
    'رقم السرير',
    'اسم الحاج',
    'الجنس',
    'الدولة',
    'الباقة',
    'المرشد'
  ]], { origin: 'A1' });

  // Set column widths
  ws['!cols'] = [
    { wch: 20 }, // camp_name
    { wch: 20 }, // table_name
    { wch: 10 }, // tent_number
    { wch: 10 }, // hall_number
    { wch: 10 }, // bed_index
    { wch: 30 }, // pilgrim_name
    { wch: 10 }, // pilgrim_gender
    { wch: 20 }, // pilgrim_country
    { wch: 25 }, // pilgrim_package
    { wch: 20 }, // guide_name
  ];

  // Create workbook and append worksheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Camp Accommodation');

  // Generate filename with current date
  const date = new Date().toISOString().split('T')[0];
  const filename = `${table.campName}-accommodation-${date}.xlsx`;

  // Save file
  XLSX.writeFile(wb, filename);
};